import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;
export default {
    getAppointmentTypes(params) {
        return Axios.get(`${baseURL}account/appointment-type`, {
            params
        }).then(response => response);
    },
    getExtension() {
        return Axios.get(`${baseURL}account/extension`).then(
            response => response
        );
    },
    getLetter() {
        return Axios.get(`${baseURL}account/template/letter`).then(
            response => response
        );
    },
    reorderAppointmentType(params) {
        return Axios.post(
            `${baseURL}account/appointment-type-reorder`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    deleteAppointmentType(id) {
        return Axios.delete(`${baseURL}account/appointment-type/${id}`).then(
            res => {
                if (res && res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    updateAppointmentType(params) {
        return Axios.put(
            `${baseURL}account/appointment-type/${params.id}`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    }
};
